// 微信位置处理类
class WxLocation {
    constructor() {}

    getLocation() {
        console.log('wx.getLocation');
        return new Promise((resolve, reject) => {
            window.wx.ready(function() {
                console.log('ready wx.getLocation');
                window.wx.getLocation({
                    type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: function(res) {
                        // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                        // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                        // var speed = res.speed; // 速度，以米/每秒计
                        // var accuracy = res.accuracy; // 位置精度
                        resolve({
                            latitude: res.latitude,
                            longitude: res.longitude,
                        });
                    },
                    fail: function(error) {
                        reject('获取定位失败', error);
                    },
                    cancel: function(error) {
                        reject('用户拒绝授权', error);
                    },
                });
            });
        });
    }

    openLocation(options) {
        let target = options;
        return new Promise((resolve, reject) => {
            window.wx.openLocation({
                latitude: target.gcjLatitude, // 纬度，浮点数，范围为90 ~ -90
                longitude: target.gcjLongitude, // 经度，浮点数，范围为180 ~ -180。
                name: target.name, // 位置名
                address: target.address, // 地址详情说明

                scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
                success: function(res) {
                    resolve(res);
                },
                fail: function(error) {
                    console.log(error);
                    reject(error);
                },
            });
        });
    }
}

export default WxLocation;
